$(document).ready(function(){
  
  /* ================================================== */
  /* SUMMARY / DETAILS
  /* ================================================== */  

  if (!$('body').hasClass('type--archives')) {
    $('details:not(.type--event)').on('click', function(){
      if ($(this).attr('open')) {
        $(this).parents('details').removeAttr('open');
      } else {
        $('details').removeAttr('open');
        $(this).attr('open');
      }
    }); 
  } else {
    // -- Archives --
    $(document).on('click', 'details', function(){
      if (!$(this).attr('open')) {
        if ($(this).hasClass('level-1')) {
          $('details.level-1').removeAttr('open');
        } else if($(this).hasClass('level-2')) {
          $('details.level-2').removeAttr('open');
        } else if($(this).hasClass('level-3')) {
          $('details.level-3').removeAttr('open');

        }
      }
    });
  }

	
	/* ================================================== */
  /* SUMMARY / DETAILS FOR NO SUPPORT
  /* ================================================== */  

	$('html').addClass($.fn.details.support ? 'details' : 'no-details');
	
	$('details').details();

});